import { z } from 'zod'
import { UPLOAD_BATCH_MAX_ITEMS } from './batch-uploader.ts'

export const TaskActionEventSchema = z.object({
  action_id: z.string().min(1),
  action_seq: z.number().int().nonnegative(),
  kind: z.string().min(1),
  started_at: z.string().datetime(),
  event_seq: z.number().int().nonnegative(),
  at: z.string().datetime(),
  type: z.enum(['begin', 'checkpoint', 'end']),
  name: z.string().min(1),
  details: z.record(z.unknown()).optional(),
  action: z.object({
    label: z.string().nullable().optional(),
    status: z.enum(['ok', 'error']).optional(),
    data: z.unknown().optional(),
    meta: z.record(z.unknown()).nullable().optional(),
    llm_job_ids: z.array(z.string()).optional(),
    depends_on: z.array(z.string()).optional(),
    error: z.string().nullable().optional(),
  }).optional(),
})
export type TaskActionEvent = z.infer<typeof TaskActionEventSchema>
export const TaskActionEventBatchSchema = z.array(TaskActionEventSchema).min(1).max(UPLOAD_BATCH_MAX_ITEMS)
export const TaskActionTimingSchema = TaskActionEventSchema.pick({ event_seq: true, at: true, type: true, name: true, details: true })
